<template>
	
	
	<div class="relative w center-swiper-main" id="centerSwiper" >
		
		<div class="flex flex-between ss-swiper-tab">
			<div>
				<!--<img src="" :data-lazy='require("../../../images/about-icon.png")'class="mg-t-30" style="width:228px;height: 62px;"/>-->
				
			</div>
			<div>
				<img src="../images/1-1.png" class="ss-swiper-tab-img" v-if="swiperIndex==3" @click="swiperTo(3)" />
				<img src="../images/1.png" class="ss-swiper-tab-img" v-else @click="swiperTo(3)" />
				
				<img src="../images/3-1.png" class="ss-swiper-tab-img" v-if="swiperIndex==4" @click="swiperTo(4)" />
				<img src="../images/3.png" class="ss-swiper-tab-img" v-else @click="swiperTo(4)" />
				
				<img src="../images/2-1.png" class="ss-swiper-tab-img" v-if="swiperIndex==5" @click="swiperTo(5)" />
				<img src="../images/2.png" class="ss-swiper-tab-img" v-else @click="swiperTo(5)" />
				
			</div>
		</div>
		<div class="flex-align-center flex-between ss-swiper-tab ss-phone-swiper">
			<div>
				<!--<img src="../../../images/about-icon.png" style="width:100px;"/>-->
			</div>
			<div>
				<a href="#ssPanel1"><img src="" :data-lazy='require("../images/1.png")'class="ss-swiper-tab-img"/>
				</a>
				<a href="#ssPanel2"><img src="" :data-lazy='require("../images/2.png")'class="ss-swiper-tab-img"/></a>
				<a href="#ssPanel3"><img src="" :data-lazy='require("../images/3.png")'class="ss-swiper-tab-img"/></a>
			</div>
		</div>

		<div class="swiper-container ">
      <div class="swiper-wrapper ">
          <div class="swiper-slide">
          	<div class="flex ss-content">
          		<div>
          			<img src="" :data-lazy='require("../images/c-b1.png")' class="f-left img" style="width: 558px;height: 743px;"/>
          		</div>
          		<div class="font-26 ss-text" style="padding-left: 90px;">
          			<h2 class="ss-title ss-title-en">COMPANY PROFILE</h2>
          			<div class="ss-title">企业简介</div>
          			<div class="ss-title-mg">重科研、求实效，</div>
          			<div>用心守护孕妈全周期，</div>
          			<div>为孕妈提供安全营养的孕期零食。</div>
          			<div class="mg-t-30">「专研孕期健康零食」，</div>
          			<div>让孕期生活更加轻松愉悦。</div>
          			<div class="clear ss-bottom-icon">
          				<img src="" :data-lazy='require("../images/c-b2.png")' class="f-left"/>
          			</div>
          		</div>
          	</div>
          </div>
          <!-- <div class="swiper-slide">
          	<div class="flex ss-content">
          		<div class="relative">
          			<img src="" :data-lazy='require("../images/014.png")' class="f-left img"/>
          			<div class="ss-swiper-img-text color-103">
					  			<div style="font-size: 39px;">40年妇产科临床经验</div>
					  			<div style="font-size: 39px;">母婴保健领域专家</div>
					  			
					  			<ul class="font-16 mg-t-20">
					  				<li>首都医科大学附属北京妇产医院原院长</li>
					  				<li>妇产科学及母婴保健领域专家</li>
					  				<li>世界卫生组织母婴妇女保健研究培训合作中心主任</li>
					  				<li>妇女保健协会专家委员会委员</li>
					  				<li>主编《陈宝英孕产科学全书》《新生婴儿护理指南》等</li>
					  			</ul>
					  		</div>
          		</div>
          		<div class="font-22 ss-text">
          			<h2 class="ss-title ss-title-en">JOINT R&D</h2>
          			<div class="ss-title">重科研</div>
          			<div class="ss-swiper-people t-center" style="width: 340px;">
							  	<div class="flex font-24">
							  		<div class="">
											<img src="" :data-lazy='require("../images/015.png")' class="ss-swiper-p-img"/>
							  			<div class="">何春水</div>
							  			<div class="font-14">
								  			<div>教授</div>
									  		<div>硕士研究生</div>
									  		<div>导师</div>
								  		</div>
							  		</div>
							  		<div class="mg-l-10">
											<img src="" :data-lazy='require("../images/016.png")' class="ss-swiper-p-img"/>
							  			<div class="">杜亚松</div>
							  			<div class="font-14">
							  				<div style="opacity: 0;">医学博士</div>
								  			<div>医学博士</div>
								  		</div>
							  		</div>
							  		<div class="mg-l-10">
											<img src="" :data-lazy='require("../images/017.png")' class="ss-swiper-p-img"/>
							  			<div class="">励建安</div>
							  			<div class="font-14">
								  			<div>教授</div>
									  		<div>主任医生</div>
									  		<div>博导</div>
								  		</div>
							  		</div>
							  	</div>

							  </div>
          			<div class="font-22 pd-t-20" >
							  	<p>江南大学、集美大学</p>
							  	<p>术康营养科学联合研发</p>
							  </div>
							  
							  <img src="" :data-lazy='require("../images/sw3.png")'class="mg-t-10" style="width: 375px;" />
          		</div>
          	</div>
          </div> -->
          <div class="swiper-slide">
          	<div class="flex ss-content">
          		<div>
          			<img src="" :data-lazy='require("../images/011.png")' class="f-left img" style="width: 565px;height: 743px;"/>
          		</div>
          		<div class="font-22 ss-text" style="padding-left: 85px;">
          			<h2 class="ss-title ss-title-en">THE REAL EFFECT</h2>
          			<div class="ss-title">求实效</div>
          			<div class="clear" style="margin-top: 130px;">
				  				<img src="" :data-lazy='require("../images/012.png")' class="f-left" style="width: 85px;height: 85px;"/>
				  			</div>
				  			<div class="font-22 pd-t-20 pd-b-15" style="line-height: 32px;border-bottom: 1px solid rgb(0,0,0,0.4);letter-spacing: -1.5px;">
							  	<p>联合四川大学华西公共卫生学院</p>
							  	<p>四川大学华西妇产儿童医院开展临床研究</p>
							  </div>
							  <div class="font-16 pd-t-15">受试者食用4天后恶心呕吐评分显著下降</div>
          			
          			<div class="clear ss-bottom-icon" style="margin-top: 120px;">
          				<img src="" :data-lazy='require("../images/c-b2.png")' class="f-left"/>
          			</div>
          		</div>
          	</div>
          </div>
      </div>
      <div class="swiper-button-prev" ></div>
　　		<div class="swiper-button-next" ></div>
	  </div>
	  
	  <div class="ss-panel-1" id="ssPanel1">
	  	<div class="clear relative">
	  		<img src="" :data-lazy='require("../images/c-b1.png")' class="br-10" style="width: 100%;"/>
	  	</div>
	  	<div class="font-16 color-101 pd-t-20">
	  		<h2 class="ss-phone-title ss-phone-title-h">company profile</h2>
		  	<div class="ss-phone-title">企业简介</div>
		  	<div class="mg-t-20">重科研、求实效，</div>
  			<div>用心守护孕妈全周期，</div>
  			<div>为孕妈提供安全营养的孕期零食。</div>
  			<div class="mg-t-20">「专研孕期健康零食」，</div>
  			<div>让孕期生活更加轻松愉悦。</div>
  			<div class="clear mg-t-30">
  				<img src="" :data-lazy='require("../images/c-b2.png")' class="f-left" style="opacity: 0.3 !important;"/>
  			</div>
	  	</div>
	  </div>
	  
	  <div class="ss-panel-1" id="ssPanel2">
	  	<div class="clear relative">
	  		<img src="" :data-lazy='require("../images/014.png")' class="br-10" style="width: 100%;"/>
	  		<div class="ss-panel-img-text color-103">
	  			<div class="font-22">40年妇产科临床经验</div>
	  			<div class="font-22">母婴保健领域专家</div>
	  			
	  			<ul class="font-14 mg-t-20">
	  				<li>首都医科大学附属北京妇产医院原院长</li>
	  				<li>妇产科学及母婴保健领域专家</li>
	  				<li>世界卫生组织母婴妇女保健研究培训合作中心主任</li>
	  				<li>妇女保健协会专家委员会委员</li>
	  				<li>主编《陈宝英孕产科学全书》《新生婴儿护理指南》等</li>
	  			</ul>
	  		</div>
	  	</div>
	  	<div class="font-16 color-101 pd-t-20">
	  		<h2 class="ss-phone-title ss-phone-title-h">JOINT R&D</h2>
	  		<div class="ss-phone-title">重科研</div>
	  		<div class="ss-phone-people t-center">
			  	<div class="flex font-16">
			  		<div class="">
							<img src="" :data-lazy='require("../images/015.png")' class="ss-phone-p-img"/>
			  			<div class="mg-t-10">何春水</div>
			  			<div class="font-12">
				  			<div>教授</div>
					  		<div>硕士研究生</div>
					  		<div>导师</div>
				  		</div>
			  		</div>
			  		<div class="mg-l-30">
							<img src="" :data-lazy='require("../images/016.png")' class="ss-phone-p-img"/>
			  			<div class="mg-t-10">杜亚松</div>
			  			<div class="font-12">
			  				<div style="opacity: 0;">医学博士</div>
				  			<div>医学博士</div>
				  		</div>
			  		</div>
			  		<div class="mg-l-30">
							<img src="" :data-lazy='require("../images/017.png")' class="ss-phone-p-img"/>
			  			<div class="mg-t-10">励建安</div>
			  			<div class="font-12">
				  			<div>教授</div>
					  		<div>主任医生</div>
					  		<div>博导</div>
				  		</div>
			  		</div>
			  	</div>

			  </div>
			  <div class="font-20 pd-tb-20" style="line-height: 28px;">
			  	<p>江南大学、集美大学</p>
			  	<p>术康营养科学联合研发</p>
			  </div>
			  
			  <img src="" :data-lazy='require("../images/sw3.png")' style="width: 80%;"/>
			  
	  	</div>
	  </div>
	  
	  <div class="ss-panel-1" id="ssPanel3">
	  	<div class="clear">
	  		<img src="" :data-lazy='require("../images/011.png")' class="br-10" style="width: 100%;"/>
	  	</div>
	  	<div class="font-16 color-101 pd-t-20">
	  		<h2 class="ss-phone-title ss-phone-title-h">THE REAL EFFECT</h2>
		  	<div class="ss-phone-title">求实效</div>
		  	
		  	<div class="clear mg-t-30">
  				<img src="" :data-lazy='require("../images/012.png")' class="f-left" style="width: 60px;height: 60px;"/>
  			</div>
  			<div class="font-18 pd-tb-20" style="line-height: 28px;border-bottom: 1px solid rgb(0,0,0,0.4);">
			  	<p>联合四川大学华西公共卫生学院</p>
			  	<p>四川大学华西妇产儿童医院开展临床研究</p>
			  </div>
			  <div class="font-12 pd-t-10">受试者食用4天后恶心呕吐评分显著下降</div>
  			<div class="clear mg-t-30">
  				<img src="" :data-lazy='require("../images/c-b2.png")' class="f-left" style="opacity: 0.3 !important;"/>
  			</div>
	  	</div>
	  </div>
	  
	</div>
</template>

<script>
	import Swiper from '../../../js/swiper/js/swiper.min.js';
	var swiperInfo,that;
	export default {
	  name: 'App',
	   data() {
	      return {
	        windowWidth:this.$utils.windowWidth,
	        swiperIndex:3,
	      }
	   },
	    mounted() {
	    	this.$nextTick(function(){
	    		that = this;
					swiperInfo = new Swiper('#centerSwiper .swiper-container', {
							effect: 'coverflow',
		          loop: true,
		          grabCursor: true,
		          centeredSlides: true,
		          slidesPerView: 'auto',
		          coverflowEffect: {
		              rotate: 0,
		              stretch: 0,
		              depth: 200,
		              modifier: 1,
		              slideShadows: false,
		          },
		          pagination: {
			          el: ".swiper-pagination",
			          clickable: true,
			        },
			        navigation: {
							    nextEl: '#centerSwiper .swiper-button-next',
							    prevEl: '#centerSwiper .swiper-button-prev',
							},
							on:{
						    slideChange: function(){
						    	var activeIndex = this.activeIndex;
						    	var swiperId = document.getElementById('centerSwiper');
						    	var swiperCls = swiperId.getElementsByClassName('swiper-slide');
						    	
						    	for(let i=0 ; i<swiperCls.length ; i++){
						    		var cls = swiperCls[i].getAttribute('class');
						    		var isIndexOf = cls.indexOf('swiper-slide-atv');
						    		var splCls = cls.split('swiper-slide-atv');
						    		if(activeIndex==i){
						    			swiperCls[i].setAttribute('class',splCls[0]+' swiper-slide-atv');
						    		}else{
						    			swiperCls[i].setAttribute('class',splCls[0])
						    		}
						    	}
						    	console.log(this.activeIndex)
						    },
						  },
				    });
	    	})
	    },
	    methods:{
	    	swiperTo:function(index){
					this.swiperIndex = index;
	    		swiperInfo.slideTo(index,1000,false)
	    	}
	    }
	}
</script>

<style scoped="scoped">

	.center-swiper-main{background: url("../../../images/c-bg.png") no-repeat center;background-size: 100% 100%;
	padding:180px 0 130px 0}
	.ss-swiper-tab{width: 90%;max-width: 1430px;margin: auto;position: absolute;left: 50%;transform: translateX(-50%);top: 10px;}
	#centerSwiper .swiper-container{width: 1430px;height: 743px;padding: 30px 0;}
	#centerSwiper .img{width: 100%;height: 743px;border-top-left-radius: 40px;border-bottom-left-radius: 40px;}
	#centerSwiper .swiper-slide{width: 74%;border-radius: 40px;box-shadow: 10px 10px 10px 0 rgba(0,0,0,0.2);background: white;
	opacity: 0.3;}
	#centerSwiper .swiper-slide-atv{opacity: 1;}
	.ss-content{color: rgb(105,105,105);}
	.ss-text{padding: 65px 0 0 85px;color: rgb(75,75,75);}
	.ss-title{font-size: 47px;color: rgb(105,105,105);}
	.ss-title-en{font-size: 36px;font-weight: bold;}
	.ss-title-mg{margin-top: 200px;}
	.ss-bottom-icon{margin-top: 75px;opacity: 0.3;}
	
	#ssPanel1,#ssPanel2,#ssPanel3,.ss-phone-swiper{display: none;}
	.ss-swiper-img-text{position: absolute;left: 0;bottom: 0;padding: 35px 35px 45px 45px;}
	.ss-swiper-img-text ul{padding-left: 25px;}
	.ss-swiper-img-text li{list-style: disc;line-height: 24px;}
	
	.ss-swiper-people{padding: 25px 0;border-bottom: 1px solid rgba(0,0,0,0.4);margin-top: 105px;}
	.ss-swiper-p-img{display: block;margin: auto;width: 100px;height: 100px;}
	.ss-swiper-tab-img{width: 180px;height: 180px;margin-left: 14px;cursor: pointer;}
	
	#centerSwiper .swiper-button-prev{background: url(../images/swipericon2.png) no-repeat;width: 83px;height: 123px;left: 50px;color: rgb(200,200,200);outline: none;margin-top: -70px;}
	#centerSwiper .swiper-button-next{background: url(../images/swipericon2.png) no-repeat;width: 83px;height: 123px;right: 50px;color: rgb(200,200,200);outline: none;margin-top: -70px;
	transform: rotate(180deg);}
	#centerSwiper .swiper-button-prev:after{content: '';}
	#centerSwiper .swiper-button-next:after{content: '';}
	/*#centerSwiper .swiper-button-prev{color: #673908;}*/
	/*#centerSwiper .swiper-button-next{color: #673908;}*/
	@media screen and (max-width: 1660px) {
		#centerSwiper .swiper-container{zoom: 0.9;}
	}
	@media screen and (max-width: 1500px) {
		#centerSwiper .swiper-container{zoom: 0.8;}
	}
	@media screen and (max-width: 1300px) {
		#centerSwiper .swiper-container{zoom: 0.7;}
	}
	@media screen and (max-width: 800px) {
		#centerSwiper .swiper-container{display: none;}
		.ss-swiper-tab{display: none;}
		.ss-phone-swiper{display: flex;top: 20px;}
		#ssPanel1,#ssPanel2,#ssPanel3{display: block;}
		.ss-panel-1{border-radius: 20px;background: white;margin: 20px;margin-top: 0;
		box-shadow: 4px 4px 4px 0 rgb(0,0,0,0.05);padding: 20px;}

		.ss-phone-title{font-size: 30px;}
		.ss-phone-title-h{font-size: 22px;}
		.center-swiper-main{padding: 70px 0 30px;}
		.ss-panel-img-text{position: absolute;left: 0;bottom: 0;padding: 20px 10px;}
		.ss-phone-people{padding: 20px 0;border-bottom: 1px solid rgba(0,0,0,0.4);}
		.ss-phone-p-img{display: block;margin: auto;width: 50px;height: 50px;}
		.ss-swiper-tab-img{width: 50px;height: 50px;margin:0;margin-left: 10px;}
		
	}
</style>


